import { Collapse } from "antd"
import { ModifiedDrawer } from "components/common"
import { forwardRef, useImperativeHandle, useRef } from "react"
import { Text } from "@empglabs/backoffice-ui-kit"
import styles from "../../../../workflows/sharedComponents/index.module.less"
import { localisedValue } from "utils"
import { useTranslation } from "react-i18next"
import cx from "clsx"
import { HeaderComponent } from "../../../../workflows/sharedComponents/workflowHeaderComponent"

const WorkflowDetailDrawer = forwardRef(({ data }, ref) => {
  const { t } = useTranslation()
  const drawerRef = useRef()

  useImperativeHandle(
    ref,
    () => ({
      onVisible() {
        drawerRef?.current?.setVisible(true)
      },
    }),
    []
  )

  return (
    <ModifiedDrawer
      width={920}
      ref={drawerRef}
      title={data?.requestName}
      destroyOnClose={true}
      onClose={() => {
        drawerRef?.current?.setVisible(false)
      }}
    >
      <Text type={"secondary"} className={"mbe-24 fs14"}>
        {t("Workflow Timeline")}
      </Text>
      <Collapse expandIconPosition="end" className={cx(styles.workflowContainer)} destroyInactivePanel>
        {data?.timeline?.map((item, index) => {
          return (
            <Collapse.Panel
              className={cx(
                item?.status === "approved" && styles.approvedWorkflow,
                item?.status === "rejected" && styles.rejectedWorkFlow,
                !!(
                  item?.status === "in_progress" ||
                  item?.status === "skipped" ||
                  (item?.currentStage && item?.status === "pending")
                ) && styles.currentStageWorkflow
              )}
              key={index}
              header={
                <HeaderComponent
                  title={localisedValue({ object: item, key: "stageName" })}
                  status={
                    !!(item?.status === "in_progress" || (item?.currentStage && item?.status === "pending"))
                      ? "current"
                      : item?.status
                  }
                  showStatus={item?.status !== "pending" || item?.currentStage}
                  index={index}
                  actionBy={item?.stageAssignee}
                  actionDate={item?.date}
                  turnAroundTime={item?.turnAroundTime}
                  assignedDate={item?.assignedDate}
                />
              }
              collapsible={"disabled"}
              showArrow={false}
            />
          )
        })}
      </Collapse>
    </ModifiedDrawer>
  )
})

export default WorkflowDetailDrawer
